export default "__VITE_ASSET__BxJ9amTb__"